$(document).ready(() => {
  const currentLocale = getCurrentLocale();
  if (!$('.exportSubscriptionBtn').length) {
    return null
  };

  // Skip v1 channel when v2 export modal is present (advize_enabled)
  if (document.getElementById('exportSubscriptionsModalForm')) {
    return null;
  };

  const tooltipTitle = {
    'fr': 'Un export est déjà en cours...',
    'en': 'An export is already being generated...',
    'es': 'Ya se está generando una exportación...'
  }

  const tooltip = new bootstrap.Tooltip($('.export-tooltip')[0], {
    placement: 'top',
    title: tooltipTitle[currentLocale],
  })

  tooltip.disable();

  const $exportSubscriptionBtn = $('.exportSubscriptionBtn');
  const $exportSubscriptionsXlsxBtn = $('#exportSubscriptionsXlsxBtn');
  const $exportSubscriptionsPdfBtn = $('#exportSubscriptionsPdfBtn');
  const forms = document.querySelectorAll('.modal form');
  const $exportsSection = $('#subscriptions_exports');
  const $newExportContainer = $('.export-entries');
  const downloadTranslation = {
    'download': {
      'fr': 'Télécharger',
      'en': 'Download',
      'es': 'Descargar',
    },
    'in_progress': {
      'fr': 'En cours de chargement',
      'en': 'Loading',
      'es': 'Cargando',
    },
    'failed': {
      'fr': 'Erreur de chargement',
      'en': 'Loading error',
      'es': 'Error de carga',
    },
    'refunded': {
      'fr': 'Remboursées',
      'en': 'Refunded',
      'es': 'Reembolsadas',
    },
    'not_refunded': {
      'fr': 'En cours',
      'en': 'In progress',
      'es': 'En progreso',
    },
    'finalized': {
      'fr': 'Finalisé',
      'en': 'Finalized',
      'es': 'Finalizado',
    }
  };

  const translatedExportType = () => {
    const statusSwitcher = $('.switch-container input:checked').val();
    const statusVal = statusSwitcher.split(' ')[0];

    if (statusVal == 'pending' || statusVal == 'project_status_not_eq') {
      return downloadTranslation['not_refunded'][currentLocale];
    } else if (statusVal == 'finalized') {
      return downloadTranslation[statusVal][currentLocale];
    } else {
      return downloadTranslation['refunded'][currentLocale];
    }
  }

  const scrollToTable = () => {
    $('html, body').animate({
      scrollTop: $('.export-entries').offset().top
    }, 1000);
  }

  const displayExportsSection = () => {
    if ($exportsSection.hasClass('d-none')) { $exportsSection.removeClass('d-none') }
  }

  const addNewExportRow = (exportId, exportData) => {
    const hideFormatTd = exportData.export_type == 'cgp_subscriptions' ? 'd-none' : '';
    const new_export_row =
      `<tr id='newExportRow${exportId}'>
        <td class='export-date'>
            ${$exportSubscriptionBtn.data('current-date')}
          </td>
          <td class='export-format ${hideFormatTd}'>
            <img src='${exportData.format_image_url}' height='30' class='me-2' />
          </td>
          <td class='export-type'>
            ${translatedExportType()}
          </td>
          <td class='export-status'>
            ${exportData.status}
          </td>
          <td class='export-document'>
            <div class='spinner-bar'>
              ${$exportSubscriptionBtn.data('spinner-image')}
            </div>
          </td>
        </tr>`;
    $newExportContainer.prepend(new_export_row);
  }

  const submitBtnContent = {
    'fr': 'Générer',
    'en': 'Generate',
    'es': 'Generar',
  }

  const resetForm = (form) => {
    const submitBtn = form.querySelector('input[type=\'submit\']');
    submitBtn.disabled = false;
    submitBtn.value = submitBtnContent[currentLocale];
  }

  forms.forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();

      displayExportsSection();

      fetch(e.currentTarget.action, {
        method: 'POST',
        body: new FormData(e.currentTarget)
      })

      $('.modal.fade.show').modal('hide');
      scrollToTable();
    })
  })

  const disableExports = () => {
    tooltip.enable();
    $('.export-tooltip').on('click', () => {
      tooltip.show();
    })

    if ($exportSubscriptionsXlsxBtn.length) {
      $('#exportSubscriptionsXlsxBtn')[0].style = 'pointer-events: none; opacity: 0.5';
    }

    if ($exportSubscriptionsPdfBtn.length) {
      $('#exportSubscriptionsPdfBtn')[0].style = 'pointer-events: none; opacity: 0.5';
    }
  }

  const enableExports = () => {
    tooltip.hide();
    tooltip.disable();

    if ($exportSubscriptionsXlsxBtn.length) {
      $('#exportSubscriptionsXlsxBtn')[0].style = '';
    }

    if ($exportSubscriptionsPdfBtn.length) {
      $('#exportSubscriptionsPdfBtn')[0].style = '';
    }
  }

  App.cable.subscriptions.create(
    { channel: 'ExportSubscriptionsChannel' }, {
      received(data) {
        if (data.generating) {
          displayExportsSection();
          addNewExportRow(data.export_id, data);
          disableExports();
          forms.forEach(resetForm);
        } else if (data.success) {
          export_url = data.export_url;
          const $newExportRowEl = $(`#newExportRow${data.export_id}`);

          $newExportRowEl.find('.export-date').html(data.created_at);
          const formatImg = `<img src='${data.format_image_url}' height='30' class='me-2' />`;
          $newExportRowEl.find('.export-format').html(formatImg);
          $newExportRowEl.find('.export-type').html(data.type);
          $newExportRowEl.find('.export-status').html(data.status);

          const $downloadLink = $newExportRowEl.find('.export-document');
          const downloadLabel = downloadTranslation['download'][currentLocale];
          $downloadLink.html(
            `<a href='${export_url}' target='_blank' rel= 'noopener noreferrer nofollow'>${downloadLabel}</a>`
          );
          enableExports();
          forms.forEach(resetForm);
        } else {
          const $newExportRowEl = $(`#newExportRow${data.export_id}`);
          $newExportRowEl.find('.export-document .spinner-bar').remove();
          $newExportRowEl.find('.export-date').html(data.created_at);
          const formatImgFailed = `<img src='${data.format_image_url}' height='30' class='me-2' />`;
          $newExportRowEl.find('.export-format').html(formatImgFailed);
          $newExportRowEl.find('.export-type').html(data.type);
          $newExportRowEl.find('.export-status').html(downloadTranslation['failed'][currentLocale]);
          const failedImg = `<img src='${data.failed_icon_url}' height='30' class='me-2' />`;
          $newExportRowEl.find('.export-document').html(failedImg);
          enableExports();
          forms.forEach(resetForm);
        }
      }
    }
  );
});
